/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const GuestToken = core.serialization.object({
    token: core.serialization.string(),
    valid: core.serialization.boolean(),
});
